import React, { useContext } from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
import LogoIcon from "../../assets/svg/Logo";
import { LanguageContext } from "../../screens/LanguageContext";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  const { language, toggleLanguage } = useContext(LanguageContext); // Access the context
  
  const translations = {
    en: {
      home: "Home",
      services: "Services",
      products: "Products",
      contact: "Contact",
      switchLanguage: "العربية",
    },
    ar: {
      home: "الرئيسية",
      services: "الخدمات",
      products: "المنتجات",
      contact: "اتصل",
      switchLanguage: "English",
    },
  };

  const currentTranslations = translations[language];

  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <LogoIcon />
        </div>
        <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)} className="animate pointer">
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn" style={{ listStyle: "none" }}>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="home"
            spy={true}
            smooth={true}
            offset={-60}
          >
            {currentTranslations.home}
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="services"
            spy={true}
            smooth={true}
            offset={-60}
          >
            {currentTranslations.services}
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="projects"
            spy={true}
            smooth={true}
            offset={-60}
          >
            {currentTranslations.products}
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            to="contact"
            spy={true}
            smooth={true}
            offset={-60}
          >
            {currentTranslations.contact}
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <SwitchWrapper>
            <button onClick={toggleLanguage} className="language-button">
              {currentTranslations.switchLanguage}
            </button>
          </SwitchWrapper>
        </li>
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
`;

const SidebarHeader = styled.div`
  padding: 20px 0;
`;

const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;

const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;

const SwitchWrapper = styled.div`
  button.language-button {
    padding: 10px 15px;
    background-color: transparent;
    color: white;
    border: 1px solid white;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 15px;
    
    &:hover {
      background-color: #333;
    }
  }
`;
